export const typesList = [{
  id: 1,
  name: 'working_week'
}, {
  id: 2,
  name: 'daily'
}, {
  id: 3,
  name: 'hourly'
}, {
  id: 4,
  name: 'in_shifts'
}]
